import React, { useEffect, useState } from "react";
import Loading from "../common/Loading";
import { FaLocationDot, FaRegBuilding } from "react-icons/fa6";

import { instance } from "../config/config";
import { useNavigate } from "react-router-dom";
const Builders = () => {
  const [links, setLinks] = useState([
    {
      Dexel: "https://dexel.ca/projects.html",
    },
    {
      "Urban Capital": "https://www.urbancapital.ca",
    },
    { "Banc Group": "https://bancgroup.ca/upcoming-properties/" },
  ]);
  const [data, setData] = useState();

  useEffect(() => {
    instance
      .get("/api/builders")
      .then((res) => {
        // Assuming the response data is the array you want to display
        setData(res.data); // Update the state with the fetched data
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const navigate = useNavigate();

  const handleRedirect = (builder) => {
    links?.map((link) => {
      Object.keys(link)?.map((buildLink) => {
        if (buildLink === builder) {
          window.open(link[buildLink], "_blank");

          // navigate(link[buildLink]);
        }
        // console.log();
      });
    });
  };

  return (
    <>
      <div className="container pt-5">
        <h5>Upcoming Projects</h5>
        <div className="row builders">
          {data?.length > 0 ? (
            data?.map((build, idx) => {
              return (
                <div
                  className="col-lg-4 col-md-4 col-sm-12 my-3 cursor-pointer"
                  key={idx}
                  onClick={() => handleRedirect(build?.projectBuilder)}
                >
                  <div className="">
                    <img src={build?.projectImage} className="w-100" />
                  </div>
                  <div className="border-0 p-2 bg-white shadow">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="fw-bold">{build?.projectName}</h6>
                      <span
                        class={`badge rounded-pill bg-success mx-2 my-1 px-3 py-2 `}
                      >
                        {build?.projectStatus}
                      </span>
                    </div>
                    <p className="mb-1 text-primary-color fs-9">
                      <FaLocationDot />
                      {build?.projectLocation}
                    </p>
                    <p className="mb-1 fs-9 fw-normal">
                      {/* <FaRegBuilding /> */}
                      By:
                      <span className=" ms-1 fw-bold text-decoration-underline">
                        {build?.projectBuilder}
                      </span>
                    </p>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="w-100 d-flex justify-content-center align-items-center">
              <Loading />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Builders;
